export default __webpack_public_path__ + "static/media/bid.f920a06f.svg";